import type { ZohoContact } from '@deltasuite/zoho-client';

// Brief reframe §R1: five user-facing dispositions. Telesales / Courtesy /
// VM&E produce Zoho activities; No Answer logs Supabase audit only (per §4);
// Database Update flags the contact dropped (R3a brings the side-panel UX).
export type Disposition = 'telesales' | 'courtesy_call' | 'vme' | 'no_answer' | 'database_update';

export const POINTS_BY_DISPOSITION: Record<Disposition, number> = {
  telesales: 3,
  courtesy_call: 2,
  vme: 1,
  no_answer: 0,
  database_update: 3,
};

export const DISPOSITION_LABELS: Record<Disposition, string> = {
  telesales: 'Telesales',
  courtesy_call: 'Courtesy',
  vme: 'VM&E',
  no_answer: 'No Answer',
  database_update: 'Database Update',
};

export type RunnerView = 'setup' | 'card' | 'transition' | 'summary' | 'paused';

// Sprint runner state. Lives in browser memory only — per brief §4 "no local
// persistence beyond browser memory for the active session".
export interface RunnerState {
  view: RunnerView;
  pointTarget: number;
  /** Points already scored today before this sprint started (R4). Sprint
   * ends when startingPoints + sum(history.points) >= pointTarget. Lets
   * the card header show "today's total / daily target" rather than
   * sprint-only / daily-target. */
  startingPoints: number;
  startedAt: number | null;
  contactIndex: number;
  callPhase: 'pre' | 'live'; // pre = before dial click, live = on call
  callStartedAt: number | null;
  contacts: readonly ZohoContact[];
  history: readonly DispositionRecord[];
  lastQuoteIndex: number;
}

export interface DispositionRecord {
  contactId: string;
  contactName: string;
  disposition: Disposition;
  points: number;
  notes?: string;
  subject?: string;
  durationSeconds: number;
  occurredAt: number;
}

export interface SprintConfig {
  pointTarget: number;
  /** Today's points scored before this sprint started. Used by the runner
   * to compute "today's total" + decide when the daily target is hit. */
  startingPoints: number;
}
